import {createContext} from "react";
import {initialAlertObj} from "./Alert";
import {IAlert} from "@leap4/entities-discrepancy-common";

export const AlertContext = createContext({
    alert: initialAlertObj,
    dataPoints: [],
    setDataPoints: (dataPoints: any[]) => {},
    setAlert: (alert:IAlert) => {},
})

